import { useState } from "react";
import styled from "styled-components";
import Button from "./Button";
import InfoIcon from "icons/InfoIcon";

const Wrapper = styled.div`
  position: fixed;
  top: 8.8rem;
  left: 50%;
  transform: translateX(-50%);
  width: min(calc(100vw - 4.8rem), 60rem);
  background-color: var(--skye_blue);
  border: 1px solid var(--secondary_1);
  box-shadow: 0px 16px 40px 0px #02112814;
  border-radius: 12px;
  padding: 12px 16px;
  z-index: 12;

  .content {
    gap: 1.2rem;
    min-width: 0;
  }

  .message {
    flex: 1;
    font-size: 1.4rem;
    line-height: 2rem;
    color: var(--primary);
  }

  .actions {
    gap: 1.2rem;
    flex-shrink: 0;
  }

  @media screen and (max-width: 768px) {
    top: 15.6rem;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100vw - 2.4rem);
    padding: 1.2rem;

    .content {
      align-items: flex-start;
      flex-direction: column;
    }

    .actions {
      width: 100%;
      justify-content: space-between;
      gap: 0.8rem;
    }
  }

  @media screen and (max-width: 480px) {
    .message {
      font-size: 1.3rem;
      line-height: 1.8rem;
    }

    .actions button {
      flex: 1;
    }
  }
`;

const AppUpdateBanner = ({ visible }) => {
  const [dismissed, setDismissed] = useState(false);

  if (!visible || dismissed) {
    return null;
  }

  return (
    <Wrapper>
      <div className="content flexRow alignCenter justifyBetween">
        <InfoIcon color="var(--primary)" />
        <span className="message">
          New version available. Refresh to update.
        </span>
        <div className="actions flexRow alignCenter">
          <Button
            text="Cancel"
            className="borderedPrimary"
            height="40px"
            width="92px"
            fontSize="14px"
            onClick={() => setDismissed(true)}
          />
          <Button
            text="Refresh"
            bg="var(--primary)"
            height="40px"
            width="92px"
            fontSize="14px"
            onClick={() => window.location.reload()}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default AppUpdateBanner;
